export class Reg {
axaDOB: string;
lastName: string;
axassn: string;
ssnPasteEvent: string;
sessionId: string;

}
